import http from "../utils/http/request"
import { MethodsUrl, Filter, JsApiResult  } from "."
import { updateContentItemModel } from "../utils/http";
import { qweIsEmpty } from "../common/commonHelper";
import { ChangeField } from "../common";
import { ImportMode, UpdateQueryMode } from "../components/Import";
import { MenuViewModel } from "../components/Menu";
import { NotificationItem } from "../components/Notification";
import { InitAppModel } from "../app/appIndex";
import { LoginModel,  RedirectViewModel, UserInfo } from "../pages/login"
import { AuditTrailViewModel } from "../components/AuditTrail";

/**
 * 获取菜单
 * @returns 返回菜单模块及菜单信息
 */
let getMenu = function () {
    return http.post<MenuViewModel>(MethodsUrl.getMenu, {}, false);
}

// let getSiteInfo = function () {
//     return http.post(MethodsUrl.getSiteInfo, {}, false);
// }

/**
 * 初始化App信息
 * @returns App 站点信息及用户信息
 */
let initApp = function(){
    return http.post<InitAppModel>(MethodsUrl.initApp, {}, false);
}
/**
 * 获取登录用户身份信息
 * @returns 用户信息
 */
let getUserInfo = function () {
    return http.post<UserInfo>(MethodsUrl.getUserInfo, {}, false);
}
/**
 * 用户账户密码登录
 * @param data 登录数据
 * @returns 登录信息，成功则包含用户信息
 */
let login = function(data:LoginModel){
    return http.post<UserInfo>(MethodsUrl.login, data, false);
}

let phonelogin = function(data:LoginModel){
    return http.post<UserInfo>(MethodsUrl.phonelogin, data, false);
}
/**
 * 用户退出
 * @returns  true 退出成功
 */
let logOff = function(){
    return http.post<boolean>(MethodsUrl.logoff, {}, false);
}

let getGroupResultByKey = function(
    contentType:string,
    singleOperatorFilter:string,
    key:string
    ){
    return http.post<Array<string>>(MethodsUrl.getGroupResultByKey, {
        "contentType":contentType,
        "singleOperatorFilter":singleOperatorFilter,
        "key":key
    }, false);
}

/**
 * 查询目标表单下符合查询条件的内容项数量
 * @return 返回Promise 结果是数量
 * @param contentType { string } 目标表单
 * @param singleOperatorFilter { MultFilterArgument } 查询参数
 * @example await queryContentItemCount("Atype",{'logic':'and','filters':[{Field:'',Operator:'',Value:''})
 */
let queryContentItemCount = function(
    contentType:string,
    singleOperatorFilter:Object
){
    return http.post<Number>(MethodsUrl.queryContentItemCount, {
        "contentType":contentType,
        "singleOperatorFilter":JSON.stringify(singleOperatorFilter)
    }, false);
}

let newContentItem = function(contentType:string,params:object){
    return http.post(MethodsUrl.newContentItem + contentType , params, false);
}

let createContentItem = function(contentType:string,formData:object){
    return http.post(MethodsUrl.createContentItem + contentType , formData, false, true, { timeout:1000 * 60 * 2 });
}

let editContentItem = function(contentItemId:string,nodeId?:string,nodeidList?:Array<string>){
    return http.post(MethodsUrl.editContentItem + contentItemId , { flowCurrentNodeId: nodeId, nodeIds:nodeidList }, false);
}

let updateContentItem = function(contentItemId:string,formData:object,nodeId?:string){
    if(nodeId != undefined && !qweIsEmpty(nodeId)){
        (formData as updateContentItemModel).flowCurrentNodeId = nodeId;
    }
    return http.post(MethodsUrl.updateContentItem + contentItemId, formData, false, true, { timeout:1000 * 60 * 2 });
}

/**
 * 执行工作流操作
 * @return 返回Promise 结果是对象数组
 * @param workflowId 工作流启动Id
 * @param model 传递的参数对象
 * @example await workFlowExe("workflowId",{"a": "aValue"})
 */
let workFlowExe = function(workflowId:string, data:object){
    return http.postByJson(MethodsUrl.workflowExe + workflowId, data, true, true, { timeout:1000 * 60 * 2 });
} 

let readContentItems = function(
    contentType:string, 
    fields:Array<string>, 
    skip = 0, 
    take:number, 
    sort :Array<object> | undefined,
    filter:Filter | undefined,
    handlerUser: boolean | undefined
)
{
    if(filter?.filters.length == 0){
        filter = undefined
    }
    return http.post(MethodsUrl.readContentItems, { 
        "contentType": contentType,
        "fields":fields,
        "skip":skip,
        "take":take,
        "sort":sort,
        "filter":JSON.stringify(filter),
        "handlerUser":handlerUser
    }, false);
}

let readDataByContentItemIds = function(contentItemIds:Array<string>,fields:Array<string>,handlerUser: boolean | undefined){
    return http.post(MethodsUrl.readContentItemsByContentItemIds,{ contentItemIds:contentItemIds, fields:fields, handlerUser:handlerUser },false);
}

window.ReadContentItems = readContentItems;

let getGrid = function(gridId:string){
    return http.post(MethodsUrl.getGridDefinition + gridId, {}, false);
}

let deleteContentItems = function(contentItemIds:Array<string>){
    return http.post(MethodsUrl.deleteContentItems, { contentItemIds : contentItemIds}, true, true, { timeout:1000 * 60 * 2 });
}

let forceDeleteContentItems = function(contentItemIds:Array<string>){
    return http.post(MethodsUrl.forceDeleteContentItems, { contentItemIds : contentItemIds}, true, true, { timeout:1000 * 60 * 2 });
}

let deleteContentItem = function(contentItemId:string){
    return http.post(MethodsUrl.deleteContentItem + contentItemId,{}, true);
}


let uploadFile = function(contentType:string,fieldName:string,file:File,fileName:string){
    return http.uploadFile(MethodsUrl.uploadFile,contentType,fieldName,file,fileName);
}

let removeMedia = function(path:string){
    return http.post(MethodsUrl.removeMedia, { path: path}, true);
}

let getDashboard = function(){
    return http.post(MethodsUrl.getDashboard, {}, false);
}

let batchUpdateContentItems = function(contentItemIds:Array<string>, changeFields:Array<ChangeField>){
    return http.post(MethodsUrl.batchUpdataItem,{ contentItemIds:contentItemIds, changeFields: JSON.stringify(changeFields) }, true, true, { timeout:1000 * 60 * 2 });
}

let previewExcelData = function(path:string){
    return http.post(MethodsUrl.previewExcelData, { path:path }, true);
}

let initImportItem = function(contentType:string){
    return http.post(MethodsUrl.getFieldInfo, { contentType:contentType }, true);
}

let importDataByExcel = function(
    path:string, 
    contentType:string, 
    headRow: Number, 
    importMode:ImportMode, 
    updateQueryMode:UpdateQueryMode,
    importColumn:Array<String>,
    node:Boolean,
    needHandler:Boolean,
    parameters:string,
    onlyUpdate:Boolean,
    nodeId:string
){
    return http.post(MethodsUrl.importDataByExcel, { 
        path:path, 
        contentType:contentType, 
        headRow: headRow, 
        importMode: importMode,
        updateQueryMode: updateQueryMode,
        node : node,
        needHandler:needHandler,
        importColumn:importColumn,
        parameters:parameters,
        onlyUpdate: onlyUpdate,
        nodeId: nodeId
    }, true, false, { timeout:1000 * 60 * 2 });
}

let superImportDataByExcel = function(
    path:string, 
    contentType:string, 
    headRow: Number, 
    importMode:ImportMode, 
    updateQueryMode:UpdateQueryMode,
    importColumn:Array<String>,
    node:Boolean,
    needHandler:Boolean,
    parameters:string,
    workflows:Array<string>,
    onlyUpdate:Boolean
){
    return http.post<boolean>(MethodsUrl.superImportDataByExcel, { 
        path:path, 
        contentType:contentType, 
        headRow: headRow, 
        importMode: importMode,
        updateQueryMode: updateQueryMode,
        node : node,
        needHandler:needHandler,
        importColumn:importColumn,
        parameters:parameters,
        workflows:workflows,
        onlyUpdate: onlyUpdate
    }, true, false, { timeout:1000 * 60 * 2 });
}

let getDepart = function(departIds:Array<Number>){
    return http.post(MethodsUrl.getDepart, { departIds:departIds }, false);
}

let exportExcel = function(
    contentType:string,
    fieldString:string,
    sort :Array<object> | undefined,
    filter:string,
    displayName:string){
    return http.post(MethodsUrl.exportExcel, { 
        contentType:contentType,
        fieldString:fieldString,
        sort,
        filter,
        displayName
    }, false, true, { timeout:1000 * 60 * 2 });
}


/**
 * 查询表单定义
 * @return 返回Promise 结果是对象数组
 * @param contentType { string } 查询的表单
 * @param fields { Array<string> } 需要查询的字段列表
 * @example await getFieldDefinition("AType",["AField","BField"])
 */
let getFieldDefinition = function(contentType:string,fields:Array<string>){
    return http.post(MethodsUrl.getFieldDefinition,{ fields:fields, contentType:contentType },false);
}

let getCSRF = function(){
    return http.get(MethodsUrl.getCSRF,{ },false);
}

let getAllUser = function(userNames:Array<string>){
    return http.post(MethodsUrl.getAllUser,{ names: userNames },false);
}

let searchUser = function(nickName:string){
    return http.post(MethodsUrl.searchUser,{ nickName: nickName },false);
}
/**
 * 获取符合条件的用户列表
 * @return 返回满足条件的用户列表 结果是用户列表
 * @param filter 需要过滤的参数
 * @example await getUserByFilter({ Users:[],Depart:[],Roles:[] })
 */
let getUserByFilter = function(filter:object){
    return http.post(MethodsUrl.getUserByFilter,{ filter: filter },false);
}

let getContentAudits = function(contentItemId:string){
    return http.post<AuditTrailViewModel>(MethodsUrl.getAuditTrail + contentItemId,{ },false);
}

let getAuditDetail = function(contentItemId:string){
    return http.post(MethodsUrl.getAuditDetail + contentItemId,{ },false);
}


let getWorkflowAuditDetail = function(contentItemId:string){
    return http.post(MethodsUrl.getWorkflowAuditTrail + contentItemId,{ },false);
}

/**
 * sqlQuery查询结果
 * @return 返回Promise 结果是对象数组
 * @param name { string } 查询SQL资源名
 * @param model { object } 传递给查询的参数对象
 * @example await getQueryResult("ASql",{"a":"aValue"})
 */
let getQueryResult = function(name:string,model:object){
    return http.post<Object>(MethodsUrl.getSQLQueryResult + name,{ model:JSON.stringify(model) },false);
}

let displayContentItem = function(contentItemId:string,fields:Array<string>){
    return http.post(MethodsUrl.displayContentItem + contentItemId,{ fields:fields },false);
}

let getUsersByName = function(userNames:Array<string>){
    return http.post(MethodsUrl.getUsersByName, { names: userNames },false);
}

let getData = function(url:string){
    return http.get(url,{  },false);
}

let getFlowNodes = function(flowVersionId:string){
    return http.post(MethodsUrl.getFlowNodes + flowVersionId,{  },false);
}

let getJsApiConfig = function(url:string){
    return http.post<JsApiResult>(MethodsUrl.getJsApiConfig +"?url=" + url,{  },false);
}

let externalLogin = function(url:string){
    return http.get<RedirectViewModel>(MethodsUrl.externalLogin + "?returnUrl=" + url, {  },false);
}

let sendCode = function(phoneNumber:string){
    return http.post(MethodsUrl.sendCode, { "Phone": phoneNumber},false);
}

let checkCode = function(phoneNumber:string, code:string){
    return http.post(MethodsUrl.checkInCode, { "Phone": phoneNumber, "Code":code},false);
}

let getInfoByName = function(name:string){
    return http.post(MethodsUrl.getInfoByName + name, { },false);
}

let getNotifications = function(){
    return http.post<Array<NotificationItem>>(MethodsUrl.getNotifications, { },false);
}

let readNotificationById = function(messageId: string){
    return http.post(MethodsUrl.readNotificationById, { "MessageId":messageId },false);
}

let readAllNotification = function(){
    return http.post<NotificationItem>(MethodsUrl.readAllNotification, { },false);
}

let getUnReadNotificationCount = function(){
    return http.post(MethodsUrl.getUnReadNotificationCount,{},false);
}

/**
 * 获取系统所有的角色信息
 * @return 返回Promise 结果是角色数组
 * @example await getRoles()
 */
let getRoles = function(){
    return http.post(MethodsUrl.getRoles,{},false);
}

let queryOptions = function(
    contentType:string,
    singleOperatorFilter:string,
    key:string,
    label:string){
    return http.post(MethodsUrl.queryOptions, {
            "contentType":contentType,
            "singleOperatorFilter":singleOperatorFilter,
            "key":key,
            "label":label
        }, false);
}

let todoTask = function(skip:number, filter: object, sortDesc: boolean){
    return http.post(MethodsUrl.todoTask, { skip:skip, filter: filter, sortDesc: sortDesc }, false);
}

let ownerTask = function(skip:number, filter: object, sortDesc: boolean){
    return http.post(MethodsUrl.ownerTask, { skip:skip, filter: filter, sortDesc: sortDesc }, false);
}


/**
 * 获取流程表单里面所有的流程节点信息
 * @return 返回Promise 结果是节点信息数组
 * @param contentType 需要查询的流程表单参数
 * @example await getFlowNodesByContentType("Atype")
 */
let getFlowNodesByContentType = function(contentType:string){
    return http.post(MethodsUrl.getFlowNodesByContentType + contentType, {  },false);
}

let getFlowContentTypeList = function(){
    return http.post(MethodsUrl.getFlowContentTypeList, {  },false);
}

let getContentTypeList = function(){
    return http.post(MethodsUrl.getContentTypeList, {  },false);
}

let QweHttpRequest = {
    getInfoByName,
    getUserInfo,
    getGroupResultByKey,
    readContentItems,
    readDataByContentItemIds,
    getGrid,
    getDepart,
    getFieldDefinition,
    getQueryResult,
    queryContentItemCount,
    workFlowExe,
    getRoles,
    createContentItem,
    getFlowNodesByContentType,
    getUserByFilter,
    getContentTypeList
}

window.Qwe =  window.Qwe == undefined ? {} : window.Qwe;
window.Qwe.HttpRequest = QweHttpRequest;

export {
    getData,
    uploadFile,
    removeMedia,
    
    getMenu, 
    //getSiteInfo, 
    getUserInfo, 
    initApp, 
    login, 
    phonelogin,
    logOff, 

    getGroupResultByKey, 
    queryContentItemCount,
    queryOptions,
    newContentItem,
    createContentItem,
    editContentItem,
    updateContentItem,
    displayContentItem,
    workFlowExe,


    readContentItems,
    readDataByContentItemIds,
    deleteContentItems,
    forceDeleteContentItems,
    deleteContentItem,
    getGrid,

    batchUpdateContentItems,
    previewExcelData,
    initImportItem,
    importDataByExcel,
    superImportDataByExcel,

    exportExcel,

    getDepart,
    getFieldDefinition,
    getCSRF,

    getAllUser,
    searchUser,

    getContentAudits,
    getAuditDetail,
    getWorkflowAuditDetail,
    getQueryResult,

    getUsersByName,
    getFlowNodes,
    getFlowNodesByContentType,
    getFlowContentTypeList,
    getContentTypeList,
    getJsApiConfig,

    externalLogin,

    sendCode,
    checkCode,
    getDashboard,

    getNotifications,
    readNotificationById,
    getUnReadNotificationCount,
    readAllNotification,
    getRoles,
    
    todoTask,
    ownerTask,
    getUserByFilter
}